import { Container, Header, Spinner } from "@amzn/awsui-components-react";

import { getString } from "../ui-string-labels/ui-strings-utils";

export const DownloadLoading = () => {
    return (
        <Container>
            <Header variant="h2" data-testid="download-loading-header">
                {getString('manageOrders.table.downloadloading')}
            </Header>
            <Spinner size="large" data-testid="download-loading-spinner"/>
        </Container>
    )
}
